import type { RegionalCountryCountVariant } from '@/modules/plans/utils/regionalCatalog.utils'

type RegionalCountryCountFilterProps = {
  variants: RegionalCountryCountVariant[]
  selectedCountryCount: number | null
  onSelect: (countryCount: number) => void
}

export function RegionalCountryCountFilter({
  variants,
  selectedCountryCount,
  onSelect,
}: RegionalCountryCountFilterProps) {
  if (variants.length <= 1) return null

  return (
    <div className="mb-6 flex justify-center md:justify-start">
      <div
        className="inline-flex flex-wrap gap-1 rounded-full border border-gray-200 bg-gray-50 p-1"
        role="tablist"
        aria-label="Filter plans by country coverage"
      >
        {variants.map(variant => {
          const isActive = selectedCountryCount === variant.countryCount
          return (
            <button
              key={variant.countryCount}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onSelect(variant.countryCount)}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors md:px-6 md:py-2.5 md:text-base ${
                isActive
                  ? 'bg-telgo-red text-white shadow-sm'
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              {variant.countryCount} {variant.countryCount === 1 ? 'Country' : 'Countries'} Plan
            </button>
          )
        })}
      </div>
    </div>
  )
}
